import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Button } from '../button';
import { Modal } from '../modal';
import { Alert as AlertIcon } from '@otp/icons';
import styles from './alert.module.css';
import { useTranslation } from 'react-i18next';
export const Alert = (props) => {
    const { t } = useTranslation();
    const title = props.title || t('alert.title', 'Warning');
    const message = props.message || t('alert.message', 'Unable to complete this action.');
    const buttonMessage = props.buttonMessage || t('alert.button-text', 'Close');
    const titleElement = (_jsxs("div", { className: clsx(styles.title), children: [_jsx(AlertIcon, {}), title] }));
    const buttonElement = (_jsx(Button, { variant: "contained", color: "error", onClick: props.onClose, children: buttonMessage }));
    return (_jsx(Modal, { maxWidth: "xs", fullWidth: true, open: props.open, onClose: props.onClose, title: titleElement, actions: [buttonElement], children: message }));
};
